import { useState, useEffect } from 'react';
import axios from 'axios';

// Local Serverless API endpoint
const tokenUrl = '/api/token';

function useAmadeusAccessToken() {
  const [accessToken, setAccessToken] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchAccessToken() {
      try {
        const response = await axios.get(tokenUrl);
        
        if (response.data && response.data.access_token) {
          setAccessToken(response.data.access_token);
        } else {
          setError(new Error(response.data.error_description || "Token nahi mila"));
        }
        setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
      }
    }

    fetchAccessToken();
  }, []);

  return { accessToken, isLoading, error };
}

export default useAmadeusAccessToken;
